<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      enable-resize-watcher
      fixed
      app
      class="grey darken-4"
    >
      <side-drawer></side-drawer>
    </v-navigation-drawer>
    <v-toolbar
      app
      color="primary"
      class="elevation-1"
    >
      <v-btn icon @click="goBack()" class="white--text">
        <v-icon>keyboard_arrow_left</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-toolbar-title class="white--text">Net Profit Report{{ (month ? ' for ' + monthName(month) : '') + ' ' + (year ? ' ' + year : '') }}</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-content>
      <v-layout>
        <v-flex xs12>
          <v-card class="pa-4">
            <v-container fluid grid-list-xs class="pa-0">
              <v-layout row wrap>
                <v-flex xs12>
                  <v-container fluid grid-list-lg>
                    <v-form ref="frmLoadProfit" v-model="frmLoadProfitValid" v-on:submit.prevent>
                      <v-layout row wrap>
                        <v-flex xs6 sm3 offset-sm2>
                          <v-select
                            v-model="cboMonth"
                            :items="months"
                            item-text="name"
                            item-value="value"
                            label="Month"
                            :rules="[v => !!v || 'Month is required']"
                            required
                          ></v-select>
                        </v-flex>
                        <v-flex xs6 sm3>
                          <v-select
                            v-model="cboYear"
                            :items="years"
                            label="Year"
                            :rules="[v => !!v || 'Year is required']"
                            required
                          ></v-select>
                        </v-flex>
                        <v-flex xs6 sm1>
                          <v-btn
                            outline
                            block
                            :disabled="!frmLoadProfitValid"
                            @click="$router.push('/report/net-profit/' + cboYear + '/' + cboMonth)"
                          >
                            <v-icon>search</v-icon>
                          </v-btn>
                        </v-flex>
                        <v-flex xs6 sm1>
                          <v-btn
                            outline
                            block
                            :disabled="!frmLoadProfitValid"
                            @click="getProfit(cboYear, cboMonth, 'csv')"
                          >
                            CSV
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-form>
                  </v-container>
                </v-flex>
                <v-flex xs12 v-if="(year >= 2000 && year <= 3000) && (month >= 1 && month <= 12)">
                  <v-divider></v-divider>
                </v-flex>
                <v-flex xs12 v-if="(year >= 2000 && year <= 3000) && (month >= 1 && month <= 12)" class="pt-5">
                  <v-card flat class="pt-0" v-if="profit">
                    <v-container fluid grid-list-xs class="pt-0">
                      <v-layout row wrap>
                        <v-flex
                          xs12
                          text-xs-center
                          layout
                          align-center
                          justify-center
                          class="mt-0"
                        >
                          <table
                            class="pt-0 mt-0"
                            style="width: 100%;"
                          >
                            <tr>
                              <td width="70%" class="text-xs-left subheading font-weight-regular">
                                <strong>Branch</strong>
                                <v-btn
                                  small
                                  outline
                                  :to="'/report/profit?date1=' + year + '-' + (month < 10 ? '0' + month : month) + '-01&date2=' + year + '-' + (month < 10 ? '0' + month : month) + '-' + new Date(year, month, 0).getDate()"
                                >
                                  View
                                </v-btn>
                                <table border=0 width="100%" class="ml-3 mt-2" cellpadding=0 cellspacing=0>
                                  <tr>
                                    <td width="60%" class="no-border body-2 font-weight-regular">
                                      Total Sales
                                      <span :class="'font-weight-bold ml-2 ' + (profit.overallProfitStatus === 'complete' ? 'green--text' : 'orange--text')">({{ profit.overallProfitStatus | allCaps }})</span>
                                    </td>
                                    <td width="30%" class="no-border body-2 font-weight-regular">
                                      {{ def.currency.sign + formatPrice(profit.totalBranchSalesInBase, def.currency.decimals, def.currency.decimalSign) }}
                                    </td>
                                    <td width="10%" class="no-border body-2 font-weight-regular">
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="no-border body-2 font-weight-regular">
                                      Total Cost
                                    </td>
                                    <td class="no-border body-2 font-weight-regular" style="border-bottom:1px solid #ffffff;">
                                      {{ def.currency.sign + formatPrice(profit.totalBranchCostInBase, def.currency.decimals, def.currency.decimalSign) }}
                                    </td>
                                    <td class="no-border title font-weight-regular">
                                      -
                                    </td>
                                  </tr>
                                  <tr>
                                    <td colspan=3>
                                    </td>
                                  </tr>
                                </table>
                              </td>
                              <td width="30%" :class="(profit.totalBranchSalesInBase - profit.totalBranchCostInBase < 0 ? 'red--text' : '') + ' text-xs-right subheading font-weight-bold'" valign="bottom">
                                {{ def.currency.sign + formatPrice(profit.totalBranchSalesInBase - profit.totalBranchCostInBase, def.currency.decimals, def.currency.decimalSign) }}
                              </td>
                            </tr>
                            <tr>
                              <td class="text-xs-left subheading font-weight-regular">
                                <strong>Seller Fee</strong>
                                <table border=0 width="100%" class="ml-3 mt-2" cellpadding=0 cellspacing=0>
                                  <tr v-for="(seller, sellerIndex) in profit.sellerFees" :key="seller.sellerUserId">
                                    <td width="60%" class="no-border body-2 font-weight-regular">
                                      {{ seller.storeName }} ({{ seller.storeCountryName }})
                                    </td>
                                      <td width="30%" class="no-border body-2 font-weight-regular" :style="(sellerIndex >= (profit.sellerFees.length - 1) ? 'border-bottom:1px solid #ffffff;' : '')">
                                      {{ def.currency.sign + formatPrice(seller.sellerFeeInBase, def.currency.decimals, def.currency.decimalSign) }}
                                    </td>
                                    <td width="10%" class="no-border subheading font-weight-regular">
                                      <span v-if="sellerIndex >= (profit.sellerFees.length - 1)">+</span>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td colspan=3>
                                    </td>
                                  </tr>
                                </table>
                              </td>
                              <td :class="(profit.totalSellerFeeInBase < 0 ? 'red--text' : '') + ' text-xs-right subheading font-weight-bold'" valign="bottom">
                                {{ def.currency.sign + formatPrice(profit.totalSellerFeeInBase, def.currency.decimals, def.currency.decimalSign) }}
                              </td>
                            </tr>
                            <tr>
                              <td class="text-xs-left subheading font-weight-regular">
                                <strong>Shipping (for branches)</strong>
                                <table border=0 width="100%" class="ml-3 mt-2" cellpadding=0 cellspacing=0>
                                  <tr>
                                    <td width="60%" class="no-border body-2 font-weight-regular">
                                      Collected Shipping Cost
                                    </td>
                                    <td width="30%" class="no-border body-2 font-weight-regular">
                                      {{ def.currency.sign + formatPrice(profit.totalBranchShippingCostInBase, def.currency.decimals, def.currency.decimalSign) }}
                                    </td>
                                    <td width="10%" class="no-border body-2 font-weight-regular">
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="no-border body-2 font-weight-regular">
                                      Real Shipping Cost
                                    </td>
                                    <td class="no-border body-2 font-weight-regular" style="border-bottom:1px solid #ffffff;">
                                      {{ def.currency.sign + formatPrice(profit.totalBranchRealShippingCostInBase, def.currency.decimals, def.currency.decimalSign) }}
                                    </td>
                                    <td class="no-border title font-weight-regular">
                                      -
                                    </td>
                                  </tr>
                                  <tr>
                                    <td colspan=3>
                                    </td>
                                  </tr>
                                </table>
                              </td>
                              <td :class="(profit.totalBranchShippingCostInBase - profit.totalBranchRealShippingCostInBase < 0 ? 'red--text' : '') + ' text-xs-right subheading font-weight-bold'" valign="bottom">
                                {{ def.currency.sign + formatPrice(profit.totalBranchShippingCostInBase - profit.totalBranchRealShippingCostInBase, def.currency.decimals, def.currency.decimalSign) }}
                              </td>
                            </tr>
                            <tr>
                              <td class="text-xs-left subheading font-weight-regular">
                                <strong>Payment</strong>
                                <table border=0 width="100%" class="ml-3 mt-2" cellpadding=0 cellspacing=0>
                                  <tr>
                                    <td width="60%" class="no-border body-2 font-weight-regular">
                                      Total Fee Received
                                    </td>
                                    <td width="30%" class="no-border body-2 font-weight-regular">
                                      {{ def.currency.sign + formatPrice(profit.totalPaymentFeeReceivedInBase, def.currency.decimals, def.currency.decimalSign) }}
                                    </td>
                                    <td width="10%" class="no-border body-2 font-weight-regular">
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="no-border body-2 font-weight-regular">
                                      Total Real Fee
                                    </td>
                                    <td class="no-border body-2 font-weight-regular" style="border-bottom:1px solid #ffffff;">
                                      {{ def.currency.sign + formatPrice(profit.totalPaymentRealFeeInBase, def.currency.decimals, def.currency.decimalSign) }}
                                    </td>
                                    <td class="no-border title font-weight-regular">
                                      -
                                    </td>
                                  </tr>
                                  <tr>
                                    <td colspan=3>
                                    </td>
                                  </tr>
                                </table>
                              </td>
                              <td :class="(profit.totalPaymentFeeReceivedInBase - profit.totalPaymentRealFeeInBase < 0 ? 'red--text' : '') + ' text-xs-right subheading font-weight-bold'" valign="bottom">
                                {{ def.currency.sign + formatPrice(profit.totalPaymentFeeReceivedInBase - profit.totalPaymentRealFeeInBase, def.currency.decimals, def.currency.decimalSign) }}
                              </td>
                            </tr>
                            <tr>
                              <td class="text-xs-left subheading font-weight-regular">
                                <strong>Payment Commission</strong>
                                <table border=0 width="100%" class="ml-3 mt-2" cellpadding=0 cellspacing=0>
                                  <tr v-for="(paymentMethod, paymentMethodIndex) in profit.paymentCommissions" :key="paymentMethod.paymentMethodId">
                                    <td width="60%" class="no-border body-2 font-weight-regular">
                                      {{ paymentMethod.paymentMethodName }}
                                    </td>
                                      <td width="30%" class="no-border body-2 font-weight-regular" :style="(paymentMethodIndex >= (profit.paymentCommissions.length - 1) ? 'border-bottom:1px solid #ffffff;' : '')">
                                      {{ def.currency.sign + formatPrice(paymentMethod.commissionInBase, def.currency.decimals, def.currency.decimalSign) }}
                                    </td>
                                    <td width="10%" class="no-border subheading font-weight-regular">
                                      <span v-if="paymentMethodIndex >= (profit.paymentCommissions.length - 1)">+</span>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td colspan=3>
                                    </td>
                                  </tr>
                                </table>
                              </td>
                              <td class="red--text text-xs-right subheading font-weight-bold" valign="bottom">
                                {{ def.currency.sign + formatPrice(profit.totalPaymentCommissionInBase * -1, def.currency.decimals, def.currency.decimalSign) }}
                              </td>
                            </tr>
                            <tr>
                              <td colspan="2" class="text-xs-left subheading font-weight-regular">
                                <strong>Expenses</strong>
                                <v-btn
                                  small
                                  outline
                                  :to="'/expenses/' + year + '/' + month"
                                >
                                  View
                                </v-btn>
                                <table border=0 width="100%" class="ml-3 mt-2" cellpadding=0 cellspacing=0>
                                  <tr v-for="(branch, branchIndex) in profit.expenses" :key="branchIndex">
                                    <td class="text-xs-left subheading font-weight-regular">
                                      <strong>{{ branch.branchName }}</strong>
                                      <table border=0 width="100%" class="ml-3 mt-2" cellpadding=0 cellspacing=0>
                                        <tr v-for="(expense, expenseIndex) in branch.expenses" :key="expense.expenseId">
                                          <td width="50%" class="body-2 font-weight-regular">
                                            <div>
                                              {{ expense.name }}
                                            </div>
                                          </td>
                                          <td width="30%" class="body-2 font-weight-regular" :style="(expenseIndex >= (branch.expenses.length - 1) ? 'border-bottom:1px solid #ffffff;' : '')">
                                            {{ def.currency.sign + formatPrice(expense.amountInBase, def.currency.decimals, def.currency.decimalSign) }}
                                            <span v-if="expense.currencyCode !== def.currency.currencyCode" class="caption font-weight-light grey--text ml-3">({{ expense.currencySign }}{{ formatPrice(expense.amount, expense.currencyDecimals, expense.currencyDecimalSign) }})</span>
                                          </td>
                                          <td width="20%" class="subheading font-weight-regular">
                                            <span v-if="expenseIndex >= (branch.expenses.length - 1)">+</span>
                                          </td>
                                        </tr>
                                      </table>
                                    </td>
                                    <td class="red--text text-xs-right subheading font-weight-bold" valign="bottom">
                                      {{ def.currency.sign + formatPrice(branch.totalAmountInBase * -1, def.currency.decimals, def.currency.decimalSign) }}
                                    </td>
                                  </tr>
                                </table>
                              </td>
                            </tr>
                            <tr>
                              <td colspan="2" class="text-xs-left subheading font-weight-regular">
                                <strong>Other Incomes</strong>
                                <v-btn
                                  small
                                  outline
                                  :to="'/incomes/' + year + '/' + month"
                                >
                                  View
                                </v-btn>
                                <table border=0 width="100%" class="ml-3 mt-2" cellpadding=0 cellspacing=0>
                                  <tr v-for="(branch, branchIndex) in profit.otherIncomes" :key="branchIndex">
                                    <td class="text-xs-left subheading font-weight-regular">
                                      <strong>{{ branch.branchName }}</strong>
                                      <table border=0 width="100%" class="ml-3 mt-2" cellpadding=0 cellspacing=0>
                                        <tr v-for="(income, incomeIndex) in branch.incomes" :key="income.incomeId">
                                          <td width="50%" class="body-2 font-weight-regular">
                                            <div>
                                              {{ income.name }}
                                            </div>
                                          </td>
                                          <td width="30%" class="body-2 font-weight-regular" :style="(incomeIndex >= (branch.incomes.length - 1) ? 'border-bottom:1px solid #ffffff;' : '')">
                                            {{ def.currency.sign + formatPrice(income.amountInBase, def.currency.decimals, def.currency.decimalSign) }}
                                            <span v-if="income.currencyCode !== def.currency.currencyCode" class="caption font-weight-light grey--text ml-3">({{ income.currencySign }}{{ formatPrice(income.amount, income.currencyDecimals, income.currencyDecimalSign) }})</span>
                                          </td>
                                          <td width="20%" class="subheading font-weight-regular">
                                            <span v-if="incomeIndex >= (branch.incomes.length - 1)">+</span>
                                          </td>
                                        </tr>
                                      </table>
                                    </td>
                                    <td class="text-xs-right subheading font-weight-bold" valign="bottom">
                                      {{ def.currency.sign + formatPrice(branch.totalAmountInBase, def.currency.decimals, def.currency.decimalSign) }}
                                    </td>
                                  </tr>
                                </table>
                              </td>
                            </tr>
                            <tr>
                              <td class="text-xs-left subheading font-weight-regular">
                                <strong>Others</strong>
                                <table border=0 width="100%" class="ml-3 mt-2" cellpadding=0 cellspacing=0>
                                  <tr>
                                    <td width="60%" class="no-border body-2 font-weight-regular">
                                      <div>
                                        Extra Costs
                                      </div>
                                    </td>
                                    <td width="30%" class="no-border body-2 font-weight-regular">
                                      {{ def.currency.sign + formatPrice(profit.totalExtraCostInBase, def.currency.decimals, def.currency.decimalSign) }}
                                    </td>
                                    <td width="10%" class="no-border subheading font-weight-regular">
                                      <span></span>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td width="60%" class="no-border body-2 font-weight-regular">
                                      <div>
                                        Vouchers
                                      </div>
                                    </td>
                                    <td width="30%" class="no-border body-2 font-weight-regular" style="border-bottom:1px solid #ffffff;">
                                      {{ def.currency.sign + formatPrice(profit.totalVoucherInBase, def.currency.decimals, def.currency.decimalSign) }}
                                    </td>
                                    <td width="10%" class="no-border subheading font-weight-regular">
                                      <span>+</span>
                                    </td>
                                  </tr>
                                </table>
                              </td>
                              <td class="red--text text-xs-right subheading font-weight-bold" valign="bottom">
                                {{ def.currency.sign + formatPrice((profit.totalExtraCostInBase + profit.totalVoucherInBase) * -1, def.currency.decimals, def.currency.decimalSign) }}
                              </td>
                            </tr>
                            <tr>
                              <td class="text-xs-left title font-weight-regular">
                                <strong>Total</strong>
                              </td>
                              <td :class="(profit.netProfitInBase < 0 ? 'red--text' : 'green--text') + ' text-xs-right title font-weight-bold'" valign="bottom">
                                {{ def.currency.sign + formatPrice(profit.netProfitInBase, def.currency.decimals, def.currency.decimalSign) }}
                              </td>
                            </tr>
                          </table>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>

          </v-card>
        </v-flex>
      </v-layout>

      <v-dialog
        v-model="loading"
        hide-overlay
        persistent
        width="220"
      >
        <loading></loading>
      </v-dialog>
    </v-content>

  </div>
</template>

<style scoped>

td, th {
  padding: 15px 15px;
}

</style>

<script>
import SideDrawer from '@/components/SideDrawer.vue'
import axios from 'axios'
import router from '../router'
import downloadjs from 'downloadjs'
import Loading from '@/components/Loading.vue'

export default {
  props: [
    'year',
    'month'
  ],
  components: {
    SideDrawer,
    Loading
  },
  data () {
    return {
      profile: this.$store.getters.getProfile,
      def: this.$store.getters.getDef,
      drawer: false,
      loading: false,
      cboYear: '',
      cboMonth: '',
      years: [],
      profit: [],
      currencyCode: this.$store.getters.getDef.currency.currencyCode,
      currencySign: this.$store.getters.getDef.currency.sign,
      currencyDecimals: this.$store.getters.getDef.currency.decimals,
      currencyDecimalSign: this.$store.getters.getDef.currency.decimalSign,
      exchangeRateToBase: this.$store.getters.getDef.currency.exchangeRateToBase,
      frmLoadProfitValid: false
    }
  },
  computed: {
  },
  mounted () {
    this.openDrawerForDesktop()
    this.years = this.generateYearsToCurrentYear(2020)
    if (typeof this.year !== 'undefined' && this.year > 0) {
      if (typeof this.month !== 'undefined' && this.month > 0) {
        this.getProfit(this.year, this.month)
      }
    }
  },

  methods: {
    getProfit: function (year, month, format = 'json') {
      var _this = this
      _this.loading = true
      var promise = new Promise(function (resolve, reject) {
        axios.get(process.env.VUE_APP_API_ROOT + '/v1/report/net-profit/' + year + '/' + month + '?format=' + format)
          .then(resp => {
            if (format === 'json') {
              console.log(resp.data)
              if (resp.data.status === 'success') {
                _this.profit = resp.data.data
                _this.cboYear = parseInt(year)
                _this.cboMonth = parseInt(month)
                // let totalExpenses = 0
                // for (let i in resp.data.data) {
                //   totalExpenses += resp.data.data[i].totalAmountInBase
                // }
                // _this.totalExpensesInBase = totalExpenses
              } else {
                window.alert('Invalid year / month')
              }
            } else {
              downloadjs(resp.data, 'report.' + format.toLowerCase(), resp.headers['content-type'])
            }
            _this.loading = false
            resolve()
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + _this.$route.fullPath)
              } else if (error.response.status === 403) {
                _this.showAlert(error)
              }
            }
            _this.loading = false
          })
      })
      return promise
    }
  }
}
</script>
